import React from 'react';
import { Card, Skeleton, Space, Typography } from 'antd';
import { CheckCircleOutlined, SyncOutlined, CloseCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface KnowledgeStatusProps {
    data: {
        indexed: number;
        processing: number;
        failed: number;
    };
    loading?: boolean;
}

const KnowledgeStatus: React.FC<KnowledgeStatusProps> = ({ data, loading }) => {
    const statusItems = [
        { label: '已索引', count: data?.indexed || 0, color: '#16A34A', icon: <CheckCircleOutlined /> },
        { label: '处理中', count: data?.processing || 0, color: '#F59E0B', icon: <SyncOutlined spin={data?.processing > 0} /> },
        { label: '失败', count: data?.failed || 0, color: '#EF4444', icon: <CloseCircleOutlined /> },
    ];

    return (
        <Card
            title={<span style={{ fontWeight: 600 }}>知识库状态分布</span>}
            variant="borderless"
            style={{ borderRadius: 12, height: '100%', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}
        >
            <Skeleton loading={loading} active paragraph={{ rows: 4 }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
                    {statusItems.map((item, index) => (
                        <div key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Space>
                                <div style={{ color: item.color, fontSize: 16, display: 'flex', alignItems: 'center' }}>
                                    {item.icon}
                                </div>
                                <Text style={{ fontSize: 14 }}>{item.label}</Text>
                            </Space>
                            <span style={{ fontSize: 16, fontWeight: 600, color: '#18181B' }}>{item.count}</span>
                        </div>
                    ))}
                </div>
            </Skeleton>
        </Card>
    );
};

export default KnowledgeStatus;
